import styled from 'styled-components'
import { GRAY_INFO, RED, WHITE } from 'constants/colors'

export const AllAssignees = styled.div`
  cursor: pointer;
  padding: 5px;
  font-size: 16px;
  line-height: 22px;
`

export const RemoveUserButton = styled.span`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  background: ${GRAY_INFO};
  border-radius: 50%;
  width: 14px;
  height: 14px;
  transition: 0.3s;

  &:before,
  &:after {
    position: absolute;
    content: '';
    width: 8px;
    height: 2px;
    background: ${WHITE};
    border-radius: 1px;
    top: 50%;
    left: 50%;
  }

  &:before {
    transform: translate(-50%, -50%) rotateZ(45deg);
  }

  &:after {
    transform: translate(-50%, -50%) rotateZ(-45deg);
  }

  &:hover {
    background: ${RED};
  }
`

export const AssigneeHolder = styled.div`
  position: relative;
  width: 35px;
  height: 35px;

  &:hover {
    > span {
      display: block;
    }
  }
`

export const AssigneeImage = styled.div`
  position: relative;
  width: 35px;
  min-width: 35px;
  height: 35px;
  overflow: hidden;
  margin-left: -9px;
  cursor: pointer;

  &:first-child {
    margin-left: 0;
  }

  &:nth-child(1) {
    z-index: 4;
  }

  &:nth-child(2) {
    z-index: 3;
  }

  &:nth-child(3) {
    z-index: 2;
  }

  &:nth-child(4) {
    z-index: 1;
  }

  &:hover {
    z-index: 5;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid ${WHITE};
  }
`

export const AssigneeImageInList = styled(AssigneeImage)`
  width: 28px;
  min-width: 28px;
  height: 28px;
`
